import { render, staticRenderFns } from "./top-menu.vue?vue&type=template&id=0d036b25"
import script from "./top-menu.vue?vue&type=script&lang=js"
export * from "./top-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d036b25')) {
      api.createRecord('0d036b25', component.options)
    } else {
      api.reload('0d036b25', component.options)
    }
    module.hot.accept("./top-menu.vue?vue&type=template&id=0d036b25", function () {
      api.rerender('0d036b25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/index/top/top-menu.vue"
export default component.exports